module.exports = __webpack_public_path__ + "kneel.9ac8bd30.png";